import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  Input,
} from '@angular/core';
import {
  BUTTON_LINK_ICON,
  EXTERNAL_LINK_ICON,
  INTERNAL_LINK_ICON,
} from '@rd/core/tokens/link.token';

@Component({
  selector: 'rd-shared-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent {
  @HostBinding('class.rd-shared-link') componentClass = true;
  @Input() text: string;
  @Input() path: string;
  @Input() isTargetBlank: boolean;
  @Input() showIcon = true;

  externalLinkIcon = inject(EXTERNAL_LINK_ICON);
  internalLinkIcon = inject(INTERNAL_LINK_ICON);
  buttonLinkIcon = inject(BUTTON_LINK_ICON);

  targetValue = '_self';

  isExternalPath(): boolean {
    return this.path.startsWith('http://') || this.path.startsWith('https://');
  }

  renderLink(): string {
    if (!this.path) {
      return 'buttonLink';
    }

    if (this.isExternalPath()) {
      this.setTargetValue();
      return 'externalLink';
    } else {
      return 'internalLink';
    }
  }

  private setTargetValue(): void {
    this.targetValue = this.isTargetBlank ? '_blank' : '_self';
  }
}
